<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Consulta Coparn</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button
            v-show="puedeEditar || puedeEliminar || puedeConsultar"
            class="btn-info"
            type="button"
            @click="consultar"
          >
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button
            v-show="puedeCrear"
            @click="agregar"
            class="btn-success"
            type="button"
          >
            <i class="fa fa-plus"></i><span>Nuevo</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Filtros de la consulta</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-inline">
              <label for="hoy">
                <input
                  v-model="form.tipo_fecha"
                  type="radio"
                  name="tipo_fecha"
                  id="hoy"
                  value="H"
                />
                <span>Hoy</span>
              </label>
              <label for="ayer">
                <input
                  v-model="form.tipo_fecha"
                  type="radio"
                  name="tipo_fecha"
                  id="ayer"
                  value="A"
                />
                <span>Ayer</span>
              </label>
              <label for="personalizado">
                <input
                  @change="changePersonalizado"
                  value="P"
                  v-model="form.tipo_fecha"
                  type="radio"
                  name="tipo_fecha"
                  id="personalizado"
                />
                <span>Personalizado</span>
              </label>
              <div v-show="form.tipo_fecha === 'P'" class="form-field">
                <div class="datepicker-field datepicker-field--stretch">
                  <date-picker
                    @enterkey="consultar"
                    type="date"
                    id="desde"
                    v-model="form.desde"
                  ></date-picker>
                  <label>{{ $t("message.desde") }}</label>
                  <span
                    v-if="errores.desde"
                    class="helper-text text-danger"
                    slot="helper"
                  >
                    <strong>{{ errores.desde[0] }}</strong>
                  </span>
                </div>
              </div>
              <div v-show="form.tipo_fecha === 'P'" class="form-field">
                <div class="datepicker-field datepicker-field--stretch">
                  <date-picker
                    @enterkey="consultar"
                    type="hasta"
                    id="hasta"
                    v-model="form.hasta"
                  ></date-picker>
                  <label>{{ $t("message.hasta") }}</label>
                  <span
                    v-if="errores.hasta"
                    class="helper-text text-danger"
                    slot="helper"
                  >
                    <strong>{{ errores.hasta[0] }}</strong>
                  </span>
                </div>
              </div>
              <div v-show="lineas.length > 1" class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select
                      @input="inputLinea"
                      :options="lineas"
                      label="name"
                      id="linea"
                      placeholder="Seleccione..."
                      v-model="selectedLinea"
                    ></v-select>
                    <label for="linea">Línea</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Resultados de la consulta</h5>
      </div>
      <div class="card__content">
        <tabs :options="{ defaultTabHash: 'procesados' }" @changed="tabChanged">
          <div class="form-field">
            <input-field
              @keyup.enter="consultar"
              id="search"
              placeholder="Consultar..."
              v-model="form.buscar"
            ></input-field>
          </div>
          <tab id="procesados" name="Procesados">
            <div class="table-responsive">
              <k-table
                :buttons="[
                  {
                    class: 'btn-info',
                    icon: 'fa-edit',
                    event: 'editar',
                  },
                  {
                    class: 'btn-secondary',
                    icon: 'fa-file',
                    event: 'verLogs',
                  },
                  {
                    class: 'btn-danger',
                    icon: 'fa-trash',
                    event: 'eliminar',
                  },
                ]"
                @verLogs="verLogs"
                @editar="editar"
                @eliminar="eliminar"
                noForms
                :params="form"
                :mostrarTodos="false"
                :columns="[
                  {
                    display: 'Fecha',
                    value: 'date_booking',
                  },
                  {
                    display: 'Booking',
                    value: 'booking',
                  },
                  {
                    display: 'Type',
                    value: 'descripcion_type',
                  },
                  {
                    display: 'Size',
                    value: 'size_container',
                  },
                  {
                    display: 'Exportador',
                    value: 'exportador',
                  },
                  {
                    display: 'Línea',
                    value: 'linea_id',
                  },
                  {
                    display: 'Count',
                    value: 'booking_count',
                  },
                  {
                    display: 'Despachados',
                    value: 'despachado_count',
                  },
                  {
                    display: 'Voyage',
                    value: 'voyage',
                  },
                  {
                    display: 'Remark',
                    value: 'remark',
                  },
                  {
                    display: 'Localización',
                    value: 'location_receipt',
                  },
                  {
                    display: 'Vessel',
                    value: 'vessel',
                  },
                  {
                    display: 'Temperatura',
                    value: 'temperature',
                  },
                  {
                    display: 'Ventilación',
                    value: 'ventilation',
                  },
                  {
                    display: 'Yard',
                    value: 'yard_code',
                  },
                  {
                    display: 'Marca',
                    value: 'marca',
                  },
                  {
                    display: 'Oxígeno',
                    value: 'oxigeno',
                  },
                  {
                    display: 'CO2',
                    value: 'dioxido_carbono',
                  },
                  {
                    display: 'Tipo de contenedor',
                    value: 'tipo_contenedor',
                  },
                  {
                    display: 'Procesamiento',
                    value: 'fecha_procesamiento',
                  },
                  {
                    display: 'Fichero',
                    value: 'kim_path',
                  },
                ]"
                :path="path"
                ref="consultaCoparn"
                :deleteButton="false"
                :createButton="false"
                :editButton="false"
              >
              </k-table>
            </div>
          </tab>
          <tab id="no-procesados" name="No procesados">
            <div class="table-responsive">
              <k-table
                :buttons="[
                  {
                    class: 'btn-info btn--text',
                    icon: 'fa-eye',
                    event: 'verNoProcesado',
                  },
                ]"
                @verNoProcesado="verNoProcesado"
                noForms
                :params="form"
                :mostrarTodos="false"
                :columns="[
                  {
                    display: 'Fichero',
                    value: 'path',
                  },
                  {
                    display: 'Booking',
                    value: 'identificador',
                  },
                  {
                    display: 'Fecha',
                    value: 'created_at',
                  },
                ]"
                :path="path"
                ref="consultaProcesados"
                :deleteButton="false"
                :createButton="false"
                :editButton="false"
              >
              </k-table>
            </div>
          </tab>
        </tabs>
      </div>
    </div>
    <modal
      :clickToClose="false"
      name="coparn"
      scrollable
      height="auto"
      width="85%"
    >
      <coparn
        @saved="saved"
        :tipoFormulario="tipoFormulario"
        :lineas="lineas"
        @cancelar="cancelarCoparn"
        :exportadores="exportadores"
        :tiposContenedor="tiposContenedor"
        :yards="yards"
        v-model="currentCoparn"
      ></coparn>
    </modal>
    <modal
      :clickToClose="false"
      name="logs"
      scrollable
      height="auto"
      width="65%"
    >
      <log-no-procesados
        @procesado="procesado"
        @cerrar="$modal.hide('logs')"
        :path="currentPath"
      ></log-no-procesados>
    </modal>
    <modal name="logsEcasCoparn" scrollable height="auto" width="65%">
      <logs-ecas-coparn
        @cerrar="$modal.hide('logsEcasCoparn')"
        :id="currentId"
      ></logs-ecas-coparn>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    puedeEditarAdmin: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeEliminarAdmin: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeConsultar: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeCrear: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeEditar: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeEliminar: {
      type: Boolean,
      required: false,
      default: false,
    },
    exportadores: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    tiposContenedor: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    yards: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    lineas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      path: url + "/coparn",
      form: {
        tipo_fecha: "H",
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        buscar: "",
        tipo_consulta: "P",
        linea_id: "",
      },
      errores: {},
      currentCoparn: null,
      tipoFormulario: "N",
      moment: moment,
      currentPath: "",
      currentId: "",
      selectedLinea: null,
    };
  },
  methods: {
    inputLinea: function () {
      if (this.selectedLinea !== null)
        this.form.linea_id = this.selectedLinea.code;
      else this.form.linea_id = "";
    },
    tabChanged: function (tab) {
      if (tab.tab.id == "procesados") this.form.tipo_consulta = "P";
      else this.form.tipo_consulta = "N";
      this.consultar();
    },
    verLogs: function (row) {
      this.currentId = row.kim_id;
      this.$modal.show("logsEcasCoparn");
    },
    procesado: function () {
      this.currentPath = "";
      this.$modal.hide("logs");
      this.consultar();
    },
    verNoProcesado: function (coparn) {
      this.currentPath = coparn.path;
      this.$modal.show("logs");
    },
    changePersonalizado: function () {
      let today = new Date();
      let desde = new Date();
      desde.setDate(desde.getDate() - 7);
      this.form.desde = moment(desde).format("YYYY-MM-DD");
      this.form.hasta = moment(today).format("YYYY-MM-DD");
    },
    saved: function () {
      this.tipoFormulario = "N";
      this.$modal.hide("coparn");
      this.consultar();
    },
    cancelarCoparn: function () {
      this.tipoFormulario = "N";
      this.$modal.hide("coparn");
    },
    editar: function (coparn) {
      if (this.puedeEditarAdmin || coparn.kim_path === null) {
        this.tipoFormulario = "E";
        this.currentCoparn = {
          booking: coparn.booking,
          date_booking: moment(coparn.date_booking).format("YYYY-MM-DD"),
          vessel: coparn.vessel,
          voyage: coparn.voyage,
          temperature: coparn.temperature,
          linea_id: coparn.linea_id,
          type: coparn.type,
          size_container: coparn.size_container,
          exportador: coparn.exportador,
          yard_code: coparn.yard_code,
          booking_count: coparn.booking_count,
          remark: coparn.remark,
          location_receipt: coparn.location_receipt,
          _method: undefined,
          ventilation: coparn.ventilation,
          marca: coparn.marca,
          oxigeno: coparn.oxigeno,
          dioxido_carbono: coparn.dioxido_carbono,
        };
        this.$modal.show("coparn");
      } else
        swal(
          "No puede editarse este registro ya que fue ingresado por un proceso automatizado.",
          "Aviso",
          "warning"
        );
    },
    eliminar: function (coparn) {
      if (this.puedeEliminarAdmin || coparn.kim_path === null) {
        let that = this;
        swal({
          title: "¿Desea eliminar el coparn seleccionado?",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.value) {
            axios
              .post(url + "/coparn" + "/" + coparn.booking, {
                _method: "DELETE",
                exportador: coparn.exportador,
                size_container: coparn.size_container,
              })
              .then(function (response) {
                swal("El coparn fue eliminado.", "Realizado", "success");
                that.consultar();
              })
              .catch(function (error) {
                if (error !== null && error !== undefined) {
                  let response = error.response;
                  if (response !== undefined && response !== null) {
                    let status = response.status;
                    if (status === 422) {
                      that.errores = response.data.errors;
                      swal("Hay errores en el formulario.", "Aviso", "warning");
                      return;
                    }
                  }
                }
                swal("Hubo un error, intente nuevamente.", "Error", "error");
              });
          }
        });
      } else
        swal(
          "No puede eliminarse este registro ya que fue ingresado por un proceso automatizado.",
          "Aviso",
          "warning"
        );
    },
    agregar: function () {
      this.tipoFormulario = "N";
      this.currentCoparn = {
        booking: "",
        date_booking: moment(new Date()).format("YYYY-MM-DD"),
        vessel: "",
        voyage: "",
        temperature: "",
        linea_id: "",
        type: "",
        size_container: "40",
        exportador: "",
        yard_code: "",
        booking_count: 0,
        remark: "",
        location_receipt: "",
        _method: undefined,
        ventilation: "",
      };
      this.$modal.show("coparn");
    },
    consultar: function () {
      if (this.puedeConsultar || this.puedeEditar || this.puedeEliminar) {
        if (this.form.tipo_consulta == "P")
          this.$refs.consultaCoparn.loadRows();
        else this.$refs.consultaProcesados.loadRows();
      }
    },
  },
  mounted: function () {
    this.changePersonalizado();
    this.consultar();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/ecas-coparn/ConsultaCoparn.vue